import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiDialogTitle from '@mui/material/DialogTitle';
import { CloseOutlined } from '@mui/icons-material';
import ToastHandler from 'components/Toast-Handler/toast-handler';

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
  paddingRight: theme.spacing(3),
}));

const DialogTitle = ({ children, onClose }) => (
  <StyledDialogTitle>
    <Typography variant='subtitle1'>{children}</Typography>
    <Box display='flex' alignItems='center' gap={2}>
      <IconButton
        aria-label="close"
        onClick={onClose}
        size="large">
        <CloseOutlined />
      </IconButton>
    </Box>
  </StyledDialogTitle>
);

const ConfirmationDialog = ({
  open,
  title,
  children,
  width,
  isProcessing,
  handleConfirm,
  handleCancel,
  handleCloseFunc,
}) => {
  return (
    <Dialog
      maxWidth={width ? width : 'sm'}
      fullWidth
      open={open}
      onClose={handleCloseFunc}
    >
      <DialogTitle
        isProcessing={isProcessing}
        onClose={handleCloseFunc}
      >
        {title}
      </DialogTitle>
      <Divider />
      <DialogContent>
        {isProcessing && <CircularProgress style={{margin: '0px 50%'}} />}        
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} color='primary' variant='contained'>Yes</Button>
        <Button onClick={handleCancel}>No</Button>
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmationDialog;